import { FormFilter } from "../../models/FormFilter";
import { PageQuery } from "../models/pageQuery";
import { FilterBy } from "../models/filterBy";
import { formFilterKeys } from "../consts/formFilterKeys";
import { filterSeparator } from "../consts/queryValueSeparators";
import { SortBy } from "../models/sortBy";
import { SortDirection } from "../models/sortDirection";
import { nameOf } from "../../functions/nameof";
import { Form } from "../../entities/form";

export function parseFormFilterToPageQuery(
    filter: FormFilter,
    sort?: SortBy
): PageQuery {
    const pq: PageQuery = {} as PageQuery;
    const filterOn: FilterBy[] = [];
    const sortBy: SortBy = sort ?? {
        field: "" + nameOf<Form>((x) => x.createdAt),
        direction: SortDirection.DESC
    };
    pq.searchTerm = filter.name;

    if (filter.ssn) {
        filterOn.push({
            field: formFilterKeys.ssn,
            value: filter.ssn
        });
    }

    if (filter.documentId) {
        filterOn.push({
            field: formFilterKeys.documentId,
            value: filter.documentId
        });
    }

    if (filter.period) {
        filterOn.push({
            field: formFilterKeys.period,
            value: `${filter.period.start.toISOString().slice(0, 10)},${filter.period.end.toISOString().slice(0, 10)}`
        });
    }

    if (filter.statusTypes?.length) {
        const value = filter.statusTypes.join(filterSeparator);
        filterOn.push({
            field: formFilterKeys.statusCode,
            value
        });
    }

    if (filter.municipalities?.length) {
        const value = filter.municipalities.join(filterSeparator);
        filterOn.push({
            field: formFilterKeys.municipalities,
            value
        });
    }

    if (filter.errorTypes?.length) {
        const value = filter.errorTypes.join(filterSeparator);
        filterOn.push({
            field: formFilterKeys.errorType,
            value
        });
    } else if (filter.onlyFormsWithError) {
        filterOn.push({
            field: formFilterKeys.onlyFormsWithError,
            value: "true"
        });
    }

    pq.filterBy = filterOn;
    pq.sortBy = sortBy;
    return pq;
}
